import React, { useCallback, useContext, useEffect, useState } from 'react';

import MetricsGate from 'components/MetricsGate';
import ScorecardProvider from '../../contextProviders/ScorecardProvider';
import TasksProvider from '../../contextProviders/TasksProvider/LocalTasksProvider';
import { SCORECARD_RESOURCE } from '../../constants';
import { PortalsContext } from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider';
import { buildShowGlobalKpiList } from '../../navigation/appRoutes';

import Scorecard, { HeaderlessScorecard } from './Scorecard';

const useScorecardLink = (scorecard: Scorecards.Scorecard) => {
  const { selectedPortal } = useContext(PortalsContext);

  const buildLink = useCallback(() => {
    return buildShowGlobalKpiList({
      scorecardId: scorecard.id,
      portal: selectedPortal,
    });
  }, [scorecard.id, selectedPortal]);
  const [link, setLink] = useState(buildLink());

  useEffect(() => {
    setLink(buildLink());
  }, [buildLink]);

  return link;
};

const ScorecardContainer = ({
  scorecard,
  isAddKpiEnabled,
  isKpisDisabled,
  isMenuEnabled,
  numberOfPeriods,
  contentType,
  isHeaderless,
}: {
  scorecard: Scorecards.Scorecard;
  isAddKpiEnabled: boolean;
  isKpisDisabled?: boolean;
  isMenuEnabled?: boolean;
  // See ScorecardProvider
  numberOfPeriods?: number;
  contentType?: 'dashboard' | 'report';
  isHeaderless?: boolean;
}) => {
  const link = useScorecardLink(scorecard);
  const [taskSources, setTaskSources] = useState<Tasks.TaskSource[]>([]);
  const [taskDestination, setTaskDestination] = useState<
    Tasks.TaskSource | undefined
  >();

  useEffect(() => {
    setTaskSources([
      {
        type: SCORECARD_RESOURCE,
        id: scorecard.id,
      },
    ]);

    setTaskDestination({
      type: SCORECARD_RESOURCE,
      id: scorecard.id,
    });
  }, [scorecard.id]);

  return (
    <MetricsGate content={scorecard} contentType="Scorecard">
      <TasksProvider sources={taskSources} destination={taskDestination}>
        <ScorecardProvider
          scorecardId={scorecard.id}
          isAddKpiEnabled={isAddKpiEnabled}
          isKpisDisabled={isKpisDisabled}
          isMenuEnabled={isMenuEnabled}
          numberOfPeriods={numberOfPeriods}
          contentType={contentType}
        >
          {isHeaderless ? (
            <HeaderlessScorecard />
          ) : (
            <Scorecard scorecard={scorecard} link={link} />
          )}
        </ScorecardProvider>
      </TasksProvider>
    </MetricsGate>
  );
};

export default ScorecardContainer;
